import { render, staticRenderFns } from "./BaoCaoXepLoaiNQLDN.vue?vue&type=template&id=39db6045&scoped=true"
import script from "./BaoCaoXepLoaiNQLDN.vue?vue&type=script&lang=ts"
export * from "./BaoCaoXepLoaiNQLDN.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db6045",
  null
  
)

export default component.exports